// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>

const headerLinks = [{
  type: 'leftMenu',
  menu: [{
    label: 'How it works',
    link: '/howitworks',
  }, {
    label: 'Quality guidelines',
    link: '/quality',
  }, {
    label: 'Packaging guidelines',
    link: '/packaging-guidelines',
  }, {
    label: 'Contact',
    link: '/contact',
  }],
}, {
  type: 'mainMenu',
  menu: [{
    label: 'login',
    link: '/login',
  }, {
    label: 'basket',
    link: '/basket',
  }],
}];

const footerLinks = [{
  label: 'YOUR ACCOUNT',
  links: [{
    label: 'Log in',
    link: '/login',
  }, {
    label: 'Forgot your password?',
    link: '/forgot-password',
  }, {
    label: 'Fundraise',
    link: '/fundraise',
  }],
}, {
  label: 'GUIDELINES',
  links: [{
    label: 'Packaging guidelines',
    link: '/packaging-guidelines',
  }, {
    label: 'Quality guidelines',
    link: '/quality',
  }]
}, {
  label: 'PRIVACY & SECURITY',
  links: [{
    label: 'Terms & Conditions',
    link: '/terms',
  }, {
    label: 'Privacy Policy',
    link: '/privacy',
  }],
}, {
  label: 'CUSTOMER SERVICE',
  links: [{
    label: 'Contact us',
    link: '/contact',
  }, {
    label: 'How it works?',
    link: '/howitworks',
  }, {
    label: 'FAQ',
    link: '/help',
  }],
}];

export {
  headerLinks,
  footerLinks
};
